/**
 * Created by BFR on 14/04/2021.
 */
define('adminMainRouter',[
  'underscore',
  'require',
  'jquery',
  'exports',
  'module',
  'logger',
  'marionette',
  'app',
  'itemPagesNameMixin'
], function (
  _,
  require,
  $,
  exports,
  module,
  Logger,
  Marionette,
  App,
  ItemPagesNameMixin
) {
  'use strict';

  var AdminRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'admin/imprintTechnologies': 'showImprintTechnologiesAdmin',
      'admin/colorSelections': 'showColorSelectionsAdmin',
      'admin/htmlTemplates': 'showHtmlTemplatesAdmin',
      'admin/phrases': 'showPhrasesAdmin',
      'admin/glossaries': 'showGlossariesAdmin',
      'admin/usergroups': 'showUserGroupsAdmin',
      'admin/emailaddresses': 'showEmailAddressesAdmin',
      'admin/snippets': 'showSnippetsAdmin',
      'admin/genericemaildomains': 'showGenericEmailDomainsAdmin',
      'admin/notifications': 'showNotificationsAdmin',
      'admin/notifications/preferences': 'showNotificationsPreferencesAdmin',
      'admin/webhookHistory': 'showWebhookHistory',
      'admin/workActivity': 'showWorkActivityAdmin',
      'admin/apiStats': 'showApiStatsAdmin',
      'admin/qrCodeGenerator': 'showQrCodeGeneratorAdmin'
    },
    onRoute: function () {
    }
  });

  var API = {
    showNotificationsAdmin: function () {
      require([
        'adminNotificationsView',
        'contentShowController'
      ], function (AdminNotificationsView,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          this.notificationsView = new AdminNotificationsView();
          App.regions.getRegion('main').currentView.getRegion('content').show(this.notificationsView);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_NOTIFICATIONS);
        });
      });
    },

    showImprintTechnologiesAdmin: function () {
      require([
        'adminImprintTechnologiesController',
        'contentShowController'
      ], function (AdminImprintTechnologiesController,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          AdminImprintTechnologiesController._showView();
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_IMPRINT_TECHNOLOGIES);
        });
      });
    },

    showColorSelectionsAdmin: function () {
      require([
        'adminColorSelectionsListView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_COLOR_SELECTIONS);
        });
      });
    },

    showHtmlTemplatesAdmin: function () {
      require([
        'adminHtmlTemplatesController',
        'contentShowController'
      ], function (adminHtmlTemplatesController,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          adminHtmlTemplatesController._showView();
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_HTMLTEMPLATES);
        });
      });
    },

    showPhrasesAdmin: function () {
      require([
        'adminPhrasesView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_PHRASES);
        });
      });
    },

    showGlossariesAdmin: function () {
      require([
        'adminGlossariesListView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_IMPRINT_GLOSSARIES);
        });
      });
    },

    showUserGroupsAdmin: function () {
      require([
        'adminUserGroupsListView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_USER_GROUPS);
        });
      });
    },

    showEmailAddressesAdmin: function () {
      require([
        'adminEmailAddressesListView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_EMAIL_ADDRESSES);
        });
      });
    },

    showSnippetsAdmin: function () {
      require([
        'adminSnippetsListView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_SNIPPETS);
        });
      });
    },

    showGenericEmailDomainsAdmin: function () {
      require([
        'adminGenericEmailDomainsListView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_GENERIC_EMAIL_DOMAINS);
        });
      });
    },

    showWebhookHistory: function () {
      require([
        'adminWebhookHistoryView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_WEBHOOK_HISTORY);
        });
      });
    },

    showWorkActivityAdmin: function () {
      require([
        'adminWorkActivityListView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_WORK_ACTIVITY);
        });
      });
    },

    showApiStatsAdmin: function () {
      require([
        'adminApiStatsListView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_API_STATS);
        });
      });
    },

    showQrCodeGeneratorAdmin: function () {
      require([
        'adminQrCodeGeneratorView',
        'contentShowController'
      ], function (View,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_QRCODE_GENERATOR);
        });
      });
    },

    showNotificationsPreferencesAdmin: function () {
      require([
        'adminNotificationPreferenceView',
        'contentShowController'
      ], function (AdminNotificationPreferenceView,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new AdminNotificationPreferenceView();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.ADMIN_NOTIFICATIONS_PREFERENCES);

        });
      });
    }
  };

  App.on('admin:show', function () {
    App.navigate('admin');
    //API.showSuperAdmin();
  });

  App.on('before:start', function () {
    new AdminRouter({
      controller: API
    });
  });

  module.exports = AdminRouter;
});

